import { DisplayLabels, Model, Pair } from "src/components/survey/ApplicationIdentity/model/utils";

export function lastModified(model: Model): Pair {
    return {
        label: DisplayLabels.LastModified,
        value: new Date(model.application.metaDataLastUpdate).toUTCString(),
    };
}
